import { useState } from "react";
import { saveItemType } from "../Api/ItemTypeMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo"; // Loader

const ItemTypeMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [itemTypeData, setItemTypeData] = useState({
    code: "",
    description: "",
  });

  const handleChange = (e) => {
    setItemTypeData({ ...itemTypeData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveItemType(itemTypeData);
      toast.success("🟢 Item Type Added Successfully");
      setItemTypeData({ code: "", description: "" });
      navigate("/viewItemTypes");
    } catch (error) {
      toast.error("🔴 Some Error Happened");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      
        <div className="main-content expand">
          <Container fluid className="fields-container">
            <h2 className="fields-title">Item Type Master</h2>
            <Form onSubmit={handleSubmit} className="fields-form">
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Code <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="code"
                      value={itemTypeData.code}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Description <span className="text-red">**</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="description"
                      value={itemTypeData.description}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="fields-btn-container">
                <Button variant="primary" type="submit" className="fields-submit">
                  Save Item Type
                </Button>
              </div>
            </Form>
          </Container>
        </div>
      
      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </>
  );
};

export default ItemTypeMaster;
